
import axios from 'axios'
// import Vue from 'vue'

const state = {
  loading: false,
  refCount: 0,
  locale: "pl"
}

const getters = {
  listaTematy: state => state.listaTematy,
  textSearch: state => state.textSearch
}

const actions = {
  set_locale({ commit }, value) {
    commit("SET_LOCALE", value);
  }
}

const mutations = {
  SET_LOCALE(state, value) {
    state.locale = value;
  },
  SET_LOADING(state, loading) {
    if (loading) {
      state.refCount++;
      state.loading = loading;
    } else {
      state.refCount--;
      state.loading = loading;
    }

    state.loading = state.refCount == 0 ? false : true;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js